import React, { useState, useEffect } from 'react';

const ViewEventsPage = () => {
  const [events, setEvents] = useState([
    {
      id: 1,
      membership_id: '12345',
      lom_name: 'Zone A',
      program_name: 'Training Program 1',
      category: 'Fitness',
      event_date: '2025-01-15',
      event_time: '10:00 AM',
      event_duration: '2 Hours',
      last_date_to_apply: '2025-01-10',
      status :'onGoing',
    },
    {
      id: 2,
      membership_id: '67890',
      lom_name: 'Zone B',
      program_name: 'Training Program 2',
      category: 'Health',
      event_date: '2025-02-10',
      event_time: '2:00 PM',
      event_duration: '3 Hours',
      last_date_to_apply: '2025-02-05',
      status:'completed',
    },
  ]);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-16 space-y-6 mb-10">
      <div className="w-full max-w-7xl mx-auto mt-14 bg-white dark:bg-[#1a202c] rounded-xl shadow-2xl p-6">
        <h1 className="text-2xl font-bold text-gray-800 mb-6">View Events</h1>

        <table className="min-w-full border-collapse">
          <thead>
            <tr>
              <th className="border px-4 py-2">Membership ID</th>
              <th className="border px-4 py-2">LOM Name</th>
              <th className="border px-4 py-2">Program Name</th>
              <th className="border px-4 py-2">Category</th>
              <th className="border px-4 py-2">Event Date</th>
              <th className="border px-4 py-2">Event Time</th>
              <th className="border px-4 py-2">Duration</th>
              <th className="border px-4 py-2">Last Date to Apply</th>
              <th className="border px-4 py-2">Status</th>
            </tr>
          </thead>
          <tbody>
            {events.map((event) => (
              <tr key={event.id}>
                <td className="border px-4 py-2">{event.membership_id}</td>
                <td className="border px-4 py-2">{event.lom_name}</td>
                <td className="border px-4 py-2">{event.program_name}</td>
                <td className="border px-4 py-2">{event.category}</td>
                <td className="border px-4 py-2">{event.event_date}</td>
                <td className="border px-4 py-2">{event.event_time}</td>
                <td className="border px-4 py-2">{event.event_duration}</td>
                <td className="border px-4 py-2">{event.last_date_to_apply}</td>
                <td className="border px-4 py-2">{event.status}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {events.length === 0 && (
          <p className="text-center text-gray-500 mt-4">No events found.</p>
        )}
      </div>
    </div>
  );
};

export default ViewEventsPage;
